export const SOURCE_COMPONENT = {
	ATLASSIAN_SWITCHER: 'atlassianSwitcher',
	PROJECT_PAGES: 'project-pages',
	TWC_MARKETING_EMAIL: 'marketingEmail',
	CONFLUENCE_HOME: 'confluenceHome',
	WAC: 'wac',
	STORYBOOK: 'storybook',
	TEST: 'test',
	TWC_XFLOW_CONFLUENCE_TEMPLATE: 'confluence-template-xflow',
} as const;

export const SOURCE_CONTEXT = {
	ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
	PROJECT_PAGES: 'project-pages',
	WAC_HOMEPAGE_TWC_OFFER: 'wacHomepageTwcOffer',
	STORYBOOK: 'storybook',
	TEST: 'test',
	// TWC Marketing Email (twc-marketing-email-v2) CTA contexts
	JIRA_PLATFORM_TOP_CTA: 'jiraPlatformTopCta',
	JIRA_PLATFORM_BOTTOM_CTA: 'jiraPlatformBottomCta',
	JIRA_ARTICLE_TOP_CTA: 'jiraArticleTopCta',
	JIRA_ARTICLE_BOTTOM_CTA: 'jiraArticleBottomCta',
	JIRA_DATA_TOP_CTA: 'jiraDataTopCta',
	JIRA_DATA_BOTTOM_CTA: 'jiraDataBottomCta',
	CONFLUENCE_PLATFORM_TOP_CTA: 'confluencePlatformTopCta',
	CONFLUENCE_PLATFORM_BOTTOM_CTA: 'confluencePlatformBottomCta',
	CONFLUENCE_ARTICLE_TOP_CTA: 'confluenceArticleTopCta',
	CONFLUENCE_ARTICLE_BOTTOM_CTA: 'confluenceArticleBottomCta',
	CONFLUENCE_DATA_TOP_CTA: 'confluenceDataTopCta',
	CONFLUENCE_DATA_BOTTOM_CTA: 'confluenceDataBottomCta',
	JIRA_CONF_PLATFORM_TOP_CTA: 'jiraConfPlatformTopCta',
	JIRA_CONF_PLATFORM_BOTTOM_CTA: 'jiraConfPlatformBottomCta',
	JIRA_CONF_ARTICLE_TOP_CTA: 'jiraConfArticleTopCta',
	JIRA_CONF_ARTICLE_BOTTOM_CTA: 'jiraConfArticleBottomCta',
	JIRA_CONF_DATA_TOP_CTA: 'jiraConfDataTopCta',
	JIRA_CONF_DATA_BOTTOM_CTA: 'jiraConfDataBottomCta',
	// TWCG-1794: atlassian-switcher Loom intercept (offer TWC over standalone Loom)
	ATLASSIAN_SWITCHER_LOOM_INTERCEPT: 'atlassianSwitcherLoomIntercept',
	LOOM_MEETINGS_PILL: 'loomMeetingsPill',
	CONFLUENCE_XFLOW_SIDENAV: 'confluence-xflow-sidenav',
	CONFLUENCE_XFLOW_FLAG: 'confluence-xflow-flag',
	CONFLUENCE_MEETINGS_TAB: 'confluence-meetings-tab',
} as const;
